import { FC } from 'react';
import { parseTaggedText } from '../taggedText';

interface DisputeTaggedTextProps {
  text?: string | null;
}

const TAG_CLASS_NAME = {
  b: 'font-bold text-primaryText',
  hl: 'font-bold text-secondary'
};

export const DisputeTaggedText: FC<DisputeTaggedTextProps> = ({ text }) => {
  const spans = parseTaggedText(text);
  if (!spans.length) return null;

  return (
    <>
      {spans.map((span, index) => {
        if (!span.tag) return <span key={`text-${index}`}>{span.text}</span>;
        return (
          <span key={`${span.tag}-${index}`} className={TAG_CLASS_NAME[span.tag]}>
            {span.text}
          </span>
        );
      })}
    </>
  );
};
